import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "registry-link",
  class RegistryLink extends WYATTElement {
    constructor() {
      super();

      this.link = this.querySelector("a");

      WYATT.storingRegistryID = new Promise((resolve) => {
        this.resolvePromise = resolve;

        fetch(`${WYATT.routes.root}apps/giftregistry/manage`)
          .then((response) => response.text())
          .then(this.update.bind(this));
      });
    }

    update(html) {
      const DOM = new DOMParser().parseFromString(html, "text/html");
      const registries = DOM.querySelector("[data-registries]");
      const link = registries.querySelector(
        'a[href*="apps/giftregistry/registry"]',
      );

      if (!link) {
        this.resolvePromise();
        return;
      }

      this.link.href = link.href;
      WYATT.shopify.registry.id = link.href.split("/").pop();
      this.resolvePromise();
    }
  },
);
